import { Actor } from '../../../../settings/routes/OrganizationAccessTokensSettings/types/actor'
import { DEBT_COLLECTION_ACTOR_DESCRIPTION, DEBT_COLLECTION_ACTOR_NAME } from '../constants/debtCollectionActor'

export const getDebtCollectionActorPayload = (organizationId: string): Partial<Actor> => ({
  name: DEBT_COLLECTION_ACTOR_NAME,
  organizationId,
  description: DEBT_COLLECTION_ACTOR_DESCRIPTION,
})
